import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getBusinessProfile, updateBusinessProfile } from './api';
import { BusinessProfileResponse } from './types';
import { queryClient } from 'providers/AllProviders';

export function useGetBusinessProfile(options?: UseQueryOptions<BusinessProfileResponse, Error> | any) {
  return useQuery<BusinessProfileResponse>({
    queryKey: ['businessProfile'],
    queryFn: () => getBusinessProfile(),
    ...options
  });
}

export function useUpdateBusinessProfile() {
  return useMutation({
    mutationFn: (payload: any) => updateBusinessProfile(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['businessProfile'],
        refetchType: 'active'
      });
    }
  });
}
